import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';

const useStyles = makeStyles((theme) => (
  {
  appBar: {
    position: 'fixed',
    background: '#BD161C',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
    color: theme.palette.common.white
  },
  paper: {
    backgroundColor: theme.palette.grey[100],
  },
  closeIcon: {
    color: '#FFFFFF'
  }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function SlideUpDialog({
  open,
  onClose,
  title,
  children,
  ...restProps
}) {
  const classes = useStyles();

  return (
    <Dialog
      {...restProps}
      fullScreen
      open={open}
      onClose={onClose}
      PaperProps={{ className: classes.paper }}
      TransitionComponent={Transition}
    >
      <AppBar className={classes.appBar}>
        <Toolbar>
          <Typography
            variant="h6"
            className={classes.title}
            style={{ marginRight: 'auto' }}
          >
            {title}
          </Typography>
          <IconButton
            edge="start"
            // color="textSecondary"
            onClick={onClose}
            aria-label="close"
          >
            <CloseIcon className={classes.closeIcon} />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Toolbar />
      {children}
    </Dialog>
  );
}
